"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = __importDefault(require("../../client"));
function createPractice(token, team) {
    const data = {
        team,
    };
    return client_1.default.post('/season/createpractice', data, {
        headers: {
            Authorization: token,
        },
    });
}
exports.default = createPractice;
